var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { listen } from '@exadel/esl/modules/esl-utils/decorators';
import { ENTER, SPACE } from '@exadel/esl/modules/esl-utils/dom/keys';
import { UIPPlugin } from '../base/plugin';
/**
 * Base class for UI Playground plugin-buttons
 * Implements basic button behavior and accessibility
 */
export class UIPPluginButton extends UIPPlugin {
    /**
     * Creates button element instance
     * @param content - inner content of created element
     * @param cls - class name of created element
     */
    static create(content, cls = '') {
        const $el = document.createElement(this.is);
        $el.className = cls;
        if (typeof content === 'string')
            $el.innerHTML = content;
        if (typeof content === 'object')
            $el.appendChild(content);
        return $el;
    }
    connectedCallback() {
        super.connectedCallback();
        this.$$cls('uip-plugin-button', true);
        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'button');
        const type = this.constructor;
        if (type.defaultTitle && !this.hasAttribute('title')) {
            this.setAttribute('title', this.label || type.defaultTitle);
        }
    }
    _onClick(e) {
        e.preventDefault();
        this.onAction();
    }
    _onKeyDown(e) {
        if (e.key === ENTER || e.key === SPACE)
            this.click();
    }
}
UIPPluginButton.defaultTitle = '';
__decorate([
    listen('click')
], UIPPluginButton.prototype, "_onClick", null);
__decorate([
    listen('keydown')
], UIPPluginButton.prototype, "_onKeyDown", null);
